<app-navbar title="Menu WWW">
	<div class="button-row">
		<button class="me-4" mat-raised-button color="primary" (click)="save()">
			<i class="fas fa-check"></i>
			Zapisz
		</button>
		<button class="me-4" mat-raised-button color="warn" (click)="handleBackNavigation()">
			<i class="fas fa-chevron-left"></i>Powrót
		</button>
	</div>
</app-navbar>
<form [formGroup]="menuItemForm">
	<div class="container">
		<div class="form-floating my-4">
			<input type="text" formControlName="name" class="form-control" />
			<label for="name">Nazwa</label>
			@if (menuItemForm.controls['name'].touched && menuItemForm.controls['name'].errors?.required) {
				<mat-error>Nazwa jest wymagana</mat-error>
			}
		</div>

		<div class="form-floating my-4">
			<input type="text" formControlName="anchor" class="form-control" />
			<label for="name">Anchor</label>
			@if (menuItemForm.controls['anchor'].touched && menuItemForm.controls['anchor'].errors?.required) {
				<mat-error>Anchor jest wymagany</mat-error>
			}
		</div>

		<div class="form-floating my-4">
			<input type="text" formControlName="link" id="link" name="link" class="form-control" />
			<label for="link">Link</label>
			@if (menuItemForm.controls['link'].touched && menuItemForm.controls['link'].errors?.required) {
				<mat-error>Link jest wymagany</mat-error>
			}
		</div>

		<div class="form-floating my-4">
			<app-image-uploader
				[currentImage]="menuItemForm.controls.multimedia?.value?.url"
				(imageUploaded)="uploadImage($event)"
			></app-image-uploader>
		</div>

		<div class="form-floating my-4">
			<div class="col-11">
				<label class="form-label" for="text">Tekst nad listingiem</label>
				<ckeditor
					id="text"
					name="text"
					formControlName="textOverListing"
					[editor]="editor"
					[config]="editorConfigText"
				></ckeditor>
			</div>
		</div>

		<div class="form-floating my-4">
			<div class="col-11">
				<label class="form-label" for="text">Tekst pod listingiem</label>
				<ckeditor
					id="text"
					name="text"
					formControlName="textUnderListing"
					[editor]="editor"
					[config]="editorConfigText"
				></ckeditor>
			</div>
		</div>

		<div class="form-floating my-4">
			<div class="col-11">
				<label class="form-label" for="text">Uwagi</label>
				<ckeditor
					id="text"
					name="text"
					formControlName="text"
					[editor]="editor"
					[config]="editorConfig"
				></ckeditor>
			</div>
		</div>

		<div class="form-floating my-4">
			<select type="text" class="form-select" name="isActive" formControlName="isActive">
				<option [value]="item.id" *ngFor="let item of isActive">
					{{ item.name }}
				</option>
			</select>
			<label for="isActive">Status</label>
		</div>

		@if (pageFunction === PageFunction.EDIT) {
			<div class="d-flex justify-content-end align-items-center">
				<mat-form-field appearance="outline" class="w-25 me-4">
					<mat-label>Dodaj stronę podrzędną</mat-label>
					<input
						type="text"
						placeholder="Wybierz"
						matInput
						formControlName="selectedSubMenu"
						[matAutocomplete]="auto"
					/>
					<mat-autocomplete [displayWith]="displayFn.bind(this)" #auto="matAutocomplete">
						@for (option of filteredMenu | async; track option.id) {
							<mat-option [value]="option">{{ option.name }}</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>

				<button mat-raised-button color="primary" (click)="addItem()">Dodaj</button>
			</div>

			<mat-table #dataTable [dataSource]="subMenu">
				<ng-container matColumnDef="id">
					<mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="name">
					<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="link">
					<mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.link }}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="isActive">
					<mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<mat-form-field appearance="outline">
							<mat-select
								(selectionChange)="patchMenuItem(element.id, { isActive: element.isActive })"
								[(value)]="element.isActive"
							>
								<mat-option [value]="true">{{ MenuStates.ACTIVE }}</mat-option>
								<mat-option [value]="false">{{ MenuStates.INACTIVE }}</mat-option>
							</mat-select>
						</mat-form-field>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="edit">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let element">
						<button
							[disabled]="element.isActive"
							class="me-1"
							mat-raised-button
							color="accent"
							(click)="removeItem(element.id)"
						>
							Odepnij <i class="fas fa-undo-alt"></i>
						</button>
						<button mat-icon-button color="primary" (click)="loadSubMenu(element.id)">
							<i class="fas fa-edit"></i>
						</button>
					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
			</mat-table>
		}
	</div>
</form>
